
import { Component, Mixins, Prop } from 'vue-property-decorator';
import TheLeftPanel from '~/components/TheLeftPanel.vue';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import { beforeUpdateAndEnter } from '~/guards/EliotPanelGuard';
import { EliotModule } from '~/store/modules/eliot';
import PlantView from '~/components/Eliot/PlantView.vue';
import EliotGatewayView from '~/components/Eliot/EliotGatewayView.vue';
import User from '~/components/User/index.vue';
import { ConfigModule } from '~/store/modules/config';

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
]);
@Component({
    components: {
        TheLeftPanel,
        PlantView,
        EliotGatewayView,
        User,
    },
})
export default class EliotPanel extends Mixins(DarkThemeInfoMixin) {
    @Prop() readonly isUserInfoShown!: string;

    async beforeRouteEnter(to: any, from: any, next: any) {
        await beforeUpdateAndEnter(to, from, next);
    }
    async beforeRouteUpdate(to: any, from: any, next: any) {
        await beforeUpdateAndEnter(to, from, next);
    }
    get eliotGatewayId() {
        return EliotModule.currentGatewayId;
    }
    get plantId() {
        return EliotModule.currentPlantId;
    }
    get currentGatewayPlantId() {
        return EliotModule.currentGateway?.plantId;
    }
    get supportAppNameBase() {
        return ConfigModule.supportAppNameBase;
    }
}
